export interface Game {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  rating: number;
  ratingCount: number;
  description: string;
  tags: string[];
  featured: boolean;
  hot: boolean;
  releaseDate: string;
  platform: string[];
}

export const games: Game[] = [
  {
    id: 'game-1',
    title: '星界幻想曲',
    slug: 'star-fantasy',
    category: '角色扮演',
    categorySlug: 'rpg',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20game%20cover%20with%20magical%20warrior%20character%20holding%20sword%20against%20starry%20night%20sky%20background%2C%20vibrant%20warm%20colors%2C%20soft%20glow%20effects%2C%20clean%20illustration%20style%2C%20game%20cover%20art%20with%20ornate%20golden%20details&width=800&height=600&seq=game-cover-01&orientation=landscape',
    rating: 4.8,
    ratingCount: 12580,
    description: '踏上穿越星界的奇幻冒险之旅，探索神秘大陆，收集稀有装备，与来自各地的玩家一起挑战强大Boss。精美的二次元画风和沉浸式剧情等你来体验。',
    tags: ['二次元', '冒险', 'MMORPG', '社交'],
    featured: true,
    hot: true,
    releaseDate: '2026-06-15',
    platform: ['PC', 'iOS', 'Android'],
  },
  {
    id: 'game-2',
    title: '暗影突袭：重生',
    slug: 'shadow-strike-reborn',
    category: '动作冒险',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20cyberpunk%20action%20game%20cover%20featuring%20a%20hooded%20assassin%20silhouette%20with%20neon%20orange%20and%20red%20accents%2C%20futuristic%20cityscape%20background%2C%20dramatic%20lighting%2C%20game%20cover%20art%20style%20with%20smoke%20effects&width=800&height=600&seq=game-cover-02&orientation=landscape',
    rating: 4.6,
    ratingCount: 8920,
    description: '高自由度的动作冒险游戏，在赛博朋克风格的城市中执行秘密任务。流畅的战斗系统、丰富的武器库和深度的角色养成，让你体验真正的暗影刺客。',
    tags: ['赛博朋克', '动作', '潜行', '单机'],
    featured: true,
    hot: true,
    releaseDate: '2026-05-20',
    platform: ['PC', 'PS5', 'Xbox'],
  },
  {
    id: 'game-3',
    title: '恋爱绮谭',
    slug: 'love-romance',
    category: '恋爱养成',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20visual%20novel%20cover%20with%20beautiful%20characters%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20golden%20lighting%2C%20gentle%20atmosphere%2C%20illustration%20style%20with%20floating%20petals&width=800&height=600&seq=game-cover-03&orientation=landscape',
    rating: 4.5,
    ratingCount: 15600,
    description: '温暖治愈的恋爱养成游戏，多条感情线等你解锁。精美的CG立绘，全语音剧情，每一个选择都将影响故事的走向。找到属于你的那份心动吧。',
    tags: ['恋爱', '养成', '视觉小说', '全语音'],
    featured: false,
    hot: true,
    releaseDate: '2026-04-10',
    platform: ['iOS', 'Android', 'PC'],
  },
  {
    id: 'game-4',
    title: '帝国争霸',
    slug: 'empire-war',
    category: '策略战争',
    categorySlug: 'strategy',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20medieval%20war%20strategy%20game%20cover%20showing%20massive%20army%20battle%20with%20castles%20and%20banners%2C%20dramatic%20sunset%20sky%2C%20warm%20golden%20and%20amber%20tones%2C%20illustration%20style%20with%20detailed%20soldiers&width=800&height=600&seq=game-cover-04&orientation=landscape',
    rating: 4.7,
    ratingCount: 20100,
    description: '宏大的中世纪战争策略游戏，建立你的帝国，指挥千军万马征服世界。精妙的战术系统和真实的战争模拟，让你感受运筹帷幄的快感。',
    tags: ['策略', '战争', 'SLG', '多人'],
    featured: true,
    hot: false,
    releaseDate: '2026-03-01',
    platform: ['PC', 'iOS', 'Android'],
  },
  {
    id: 'game-5',
    title: '仙境传说RO：新篇章',
    slug: 'ro-new-chapter',
    category: '角色扮演',
    categorySlug: 'rpg',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20style%20MMORPG%20game%20cover%20with%20colorful%20characters%20in%20fantasy%20world%2C%20bright%20green%20meadows%20and%20blue%20sky%2C%20cheerful%20atmosphere%2C%20illustration%20with%20soft%20warm%20lighting%20and%20magical%20elements&width=800&height=600&seq=game-cover-05&orientation=landscape',
    rating: 4.4,
    ratingCount: 9800,
    description: '经典RO的全新续作，延续Q萌可爱的画风，加入更多创新玩法。丰富的职业系统、自由的交易市场和温馨的社交体验。',
    tags: ['Q版', 'MMORPG', '社交', '经典'],
    featured: false,
    hot: false,
    releaseDate: '2026-02-18',
    platform: ['iOS', 'Android'],
  },
  {
    id: 'game-6',
    title: '末日求生：废土',
    slug: 'survival-wasteland',
    category: '生存冒险',
    categorySlug: 'survival',
    coverImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20survival%20game%20cover%20with%20ruined%20cityscape%20and%20lone%20survivor%20character%2C%20warm%20dusty%20orange%20and%20brown%20color%20palette%2C%20dramatic%20sky%2C%20game%20cover%20art%20with%20rugged%20textures&width=800&height=600&seq=game-cover-06&orientation=landscape',
    rating: 4.9,
    ratingCount: 18200,
    description: '末日废土世界中的硬核生存体验，收集资源、建造庇护所、对抗变异生物。真实的饥饿、口渴和温度系统，每一步都需要谨慎决策。',
    tags: ['生存', '末日', '建造', '硬核'],
    featured: true,
    hot: true,
    releaseDate: '2026-07-01',
    platform: ['PC', 'PS5', 'Xbox'],
  },
  {
    id: 'game-7',
    title: '魔法学园物语',
    slug: 'magic-academy',
    category: '模拟经营',
    categorySlug: 'simulation',
    coverImage: 'https://readdy.ai/api/search-image?query=Magical%20academy%20simulation%20game%20cover%20with%20grand%20wizard%20school%20building%2C%20floating%20candles%20and%20spell%20effects%2C%20warm%20amber%20lighting%20from%20windows%2C%20fantasy%20illustration%20style%20with%20mystical%20atmosphere&width=800&height=600&seq=game-cover-07&orientation=landscape',
    rating: 4.3,
    ratingCount: 7600,
    description: '经营你的魔法学院，招收学员、安排课程、举办魔法比赛。培养最强大的魔法师，让你的学院成为魔法界的第一。',
    tags: ['模拟', '经营', '魔法', '养成'],
    featured: false,
    hot: false,
    releaseDate: '2026-01-25',
    platform: ['iOS', 'Android', 'PC'],
  },
  {
    id: 'game-8',
    title: '猎魔人：血月',
    slug: 'demon-hunter-blood-moon',
    category: '动作冒险',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Gothic%20fantasy%20action%20game%20cover%20with%20demon%20hunter%20wielding%20silver%20sword%20under%20blood%20red%20moon%2C%20dark%20forest%20background%2C%20dramatic%20crimson%20and%20gold%20accents%2C%20illustration%20style%20with%20mysterious%20vibe&width=800&height=600&seq=game-cover-08&orientation=landscape',
    rating: 4.7,
    ratingCount: 14300,
    description: '暗黑奇幻风格的猎魔人冒险，追踪并猎杀各种传说中的怪物。丰富的战斗连招系统和深度的装备打造机制。',
    tags: ['暗黑', '动作', 'RPG', '单机'],
    featured: false,
    hot: true,
    releaseDate: '2026-06-28',
    platform: ['PC', 'PS5'],
  },
  {
    id: 'game-9',
    title: '海岛物语',
    slug: 'island-story',
    category: '模拟经营',
    categorySlug: 'simulation',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20tropical%20island%20life%20simulation%20game%20cover%20with%20cute%20characters%20farming%20and%20fishing%2C%20palm%20trees%20and%20blue%20ocean%2C%20warm%20sunny%20atmosphere%2C%20bright%20cheerful%20illustration%20style&width=800&height=600&seq=game-cover-09&orientation=landscape',
    rating: 4.2,
    ratingCount: 5400,
    description: '悠闲的海岛生活模拟，种植作物、出海钓鱼、与岛民互动。轻松治愈的游戏节奏，是放松心情的最佳选择。',
    tags: ['休闲', '模拟', '治愈', '社交'],
    featured: false,
    hot: false,
    releaseDate: '2025-12-10',
    platform: ['iOS', 'Android'],
  },
  {
    id: 'game-10',
    title: '机甲风暴',
    slug: 'mecha-storm',
    category: '射击竞技',
    categorySlug: 'shooting',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20mecha%20battle%20game%20cover%20with%20giant%20robots%20fighting%20in%20urban%20cityscape%2C%20explosions%20and%20energy%20beams%2C%20warm%20orange%20and%20metallic%20tones%2C%20dynamic%20action%20illustration%20style&width=800&height=600&seq=game-cover-10&orientation=landscape',
    rating: 4.5,
    ratingCount: 11200,
    description: '驾驶巨型机甲在战场上纵横驰骋，自定义你的机体配置，与队友配合完成战术目标。流畅的操控手感和震撼的视觉效果。',
    tags: ['机甲', '射击', '竞技', '多人'],
    featured: false,
    hot: true,
    releaseDate: '2026-05-05',
    platform: ['PC', 'PS5'],
  },
  {
    id: 'game-11',
    title: '仙境咖啡馆',
    slug: 'fairy-cafe',
    category: '恋爱养成',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20anime%20style%20cafe%20game%20cover%20with%20charming%20barista%20characters%20serving%20coffee%2C%20warm%20interior%20lighting%2C%20steam%20rising%20from%20cups%2C%20romantic%20atmosphere%2C%20soft%20illustration%20with%20golden%20accents&width=800&height=600&seq=game-cover-11&orientation=landscape',
    rating: 4.6,
    ratingCount: 8900,
    description: '经营一家充满魔法的咖啡馆，遇见各具特色的客人，展开浪漫故事。精致的料理制作玩法和温暖的日常剧情。',
    tags: ['恋爱', '经营', '治愈', '养成'],
    featured: false,
    hot: false,
    releaseDate: '2026-04-22',
    platform: ['iOS', 'Android'],
  },
  {
    id: 'game-12',
    title: '地下城编年史',
    slug: 'dungeon-chronicles',
    category: '策略战争',
    categorySlug: 'strategy',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dungeon%20strategy%20game%20cover%20with%20adventurers%20exploring%20ancient%20ruins%2C%20torch%20light%20illuminating%20stone%20walls%2C%20treasure%20chests%20and%20monsters%2C%20warm%20amber%20torch%20glow%2C%20fantasy%20illustration%20style&width=800&height=600&seq=game-cover-12&orientation=landscape',
    rating: 4.8,
    ratingCount: 16700,
    description: '回合制策略地牢探索，组建你的冒险队伍，深入未知的地下城。随机生成的地图和丰富的装备掉落，每次冒险都是全新体验。',
    tags: ['策略', '地牢', 'Roguelike', '回合制'],
    featured: false,
    hot: true,
    releaseDate: '2026-03-15',
    platform: ['PC', 'iOS', 'Android'],
  },
];

export const getFeaturedGames = (): Game[] => games.filter((g) => g.featured);
export const getHotGames = (): Game[] => games.filter((g) => g.hot);
export const getGamesByCategory = (slug: string): Game[] => games.filter((g) => g.categorySlug === slug);
export const getGameById = (id: string): Game | undefined => games.find((g) => g.id === id);
export const getGameBySlug = (slug: string): Game | undefined => games.find((g) => g.slug === slug);